<template lang="pug">
aside.monitoring-detail.l-flex-column

    //- TABS
    Tabs.info-tabs(:dataTabs="dataTabs", parent="cclones")

        template(slot="content", v-if="activeTab === 'information'")
            section.detail-section

                div.item-info.item-cclone
                    div.item-id {{ ccloneInfo.id }}
                    div.l-flex-row.l-align-center
                        div.item-status(:title="ccloneStatus" :class="itemCssClasses(ccloneInfo.status)")
                        div.item-label.css-cut-long-text(:title="ccloneInfo.label") {{ ccloneInfo.label }}

                div.sub-header.l-flex-row--between
                    div.sub-header-title Details

                div.info-content
                    div.info-block
                        div.label Owner
                        div.value {{ ccloneInfo.email }}
                    div.info-block
                        div.label Active period
                        div.value.l-flex-row.l-align-center
                            div {{ formatDate(ccloneInfo.start_date) }}
                            svg-icon.icon-period-from-to(name='arrow-direction_right' size="small")
                            div {{ formatDate(ccloneInfo.end_date) }}
                    div.info-block
                        div.label Creation date
                        div.value {{ formatDate(ccloneInfo.created_at) }}
                    div.info-block
                        div.label Mode
                        div.value {{ ccloneMode }}
                    div.info-block( v-if="ccloneDisableStartAction")
                        div.label Retry
                        div.value
                            button.btn-pale.btn--small.btn--round.info-block-bootstrap(
                                :class="{ 'ui-disabled' : isEditing }"
                                :disabled="isEditing"
                                @click="onCcloneEdit"
                                ) Start

                div.sub-header.l-flex-row--between
                    div.sub-header-title Algorithm parameters
                div.info-content
                    div.info-block
                        div.label Depth
                        div.value {{ ccloneInfoDepth }}
                    div.info-block
                        div.label Min. Bucket
                        div.value {{ ccloneInfoMinBucket }}

        template(slot="content", v-if="activeTab === 'parameters'")
            section.detail-section
                div.sub-header.l-flex-row--between
                    div.sub-header-title Positive events
                div.info-content
                    div.info-block
                        div.label Type
                        div.value {{ ccloneInfoPositiveEventsType }}
                    div.info-block
                        div.label Positive ID
                        div.value {{ ccloneInfoPositiveEventsIds }}
                    div.info-block
                        div.label Max volume
                        div.value {{ ccloneInfo.max_positive_event }}
                    div.info-block
                        div.label Volume
                        div.value {{ ccloneInfoVolume }}

            section.detail-section
                div.sub-header.l-flex-row--between
                    div.sub-header-title Negative events
                div.info-content
                    div.info-block
                        div.label Type
                        div.value {{ ccloneInfoUniverseType }}
                    div.info-block
                        div.label Negative ID
                        div.value {{ ccloneInfoUniverseIds }}
                    div.info-block
                        div.label Max negative events
                        div.value {{ ccloneInfo.max_negative_event }}
                    div.info-block
                        div.label real negative events
                        div.value {{ ccloneInfoRealNegativeEvents }}

            section.detail-section(v-if="has3rdPartyMode")
                div.sub-header.l-flex-row--between
                    div.sub-header-title 3rd party
                div.info-content
                    div.info-block
                        div.label Cluster only
                        div.value {{ ccloneInfoClusterOnly }}
                    div.info-block
                        div.label Profile versioned
                        div.value {{ ccloneInfoIsProfileVersioned }}

</template>

<script>
// Avoid repeating namespace for each store action/mutation/getter/state
import { mapActions, mapMutations, mapState } from 'vuex'

import { head, split, isNil, isEmpty } from 'lodash'

import { CCLONE_DATATABS } from '@/utils/constants'
import helpers from '@/store/data/cclone/helpers'

// Components
import Panel from '@/components/common/Panel'
import Tabs from '@/components/common/Tabs'

export default {
    name: 'CcloneDetails',

    components: { Panel, Tabs },

    props: {
        ccloneInfo: { type: Object, required: false, default: () => ({}) }
    },

    data() {
        return { dataTabs: CCLONE_DATATABS }
    },

    computed: {
        // Call to state
        ...mapState('account', {
            accountId: state => state.accountId,
            userRole: state => state.userRole
        }),
        ...mapState('ui/cclone', {
            activeTabCclone: state => state.activeTab,
            isEditing: state => state.isEditing
        }),

        ccloneMode() {
            let cmode = ''
            if (this.ccloneInfo.settings.hasOwnProperty('3rdParty') && this.ccloneInfo.settings.hasOwnProperty('1stParty')) cmode = '1st and 3rd Party'
            else if (this.ccloneInfo.settings.hasOwnProperty('3rdParty')) cmode = '3rd Party'
            else if (this.ccloneInfo.settings.hasOwnProperty('1stParty')) cmode = '1st Party'
            return cmode
        },
        ccloneStatus() {
            if(this.ccloneInfo.status === 'failed' && !!this.ccloneInfo.status_message) {
                return `${this.ccloneInfo.status}: ${this.ccloneInfo.status_message.toLowerCase()}`
            }
            return this.ccloneInfo.status
        },
        ccloneInfoDepth() {
            return JSON.parse(this.ccloneInfo.model_params)['maxdepth']
        },
        ccloneInfoMinBucket() {
            return JSON.parse(this.ccloneInfo.model_params)['minbucket']
        },
        ccloneInfoPositiveEventsType() {
            return helpers.getCcloneInfo(this.ccloneInfo.positive_events, 'type')
        },
        ccloneInfoPositiveEventsIds() {
            const _ccloneInfoPositiveEventsIds = helpers.getCcloneInfo(this.ccloneInfo.positive_events, 'ids')
            return _ccloneInfoPositiveEventsIds.length >= 1 && typeof this.ccloneInfoUniverse === 'object' ? head(_ccloneInfoPositiveEventsIds) : '-'
        },
        ccloneInfoUniverse() {
            return this.ccloneInfo.negative_events !== '' ? helpers.getCcloneInfo(this.ccloneInfo.negative_events) : {}
        },
        ccloneInfoUniverseType() {
            return !isEmpty(this.ccloneInfoUniverse.type) ? this.ccloneInfoUniverse['type'] : this.has3rdPartyMode ? 'Full database' : '1st Party Universe'
        },
        ccloneInfoUniverseIds() {
            return !isEmpty(this.ccloneInfoUniverse) && typeof this.ccloneInfoUniverse === 'object' ? head(this.ccloneInfoUniverse['ids']) : '-'
        },
        has3rdPartyMode() {
            return this.ccloneInfo.settings.hasOwnProperty('3rdParty')
        },
        ccloneInfoClusterOnly() {
            return this.ccloneInfo.settings['3rdParty'].cluster_only ? 'Yes' : 'No'
        },
        ccloneInfoIsProfileVersioned() {
            return this.ccloneInfo.settings['3rdParty'].is_profile_versioned ? 'Yes' : 'No'
        },
        ccloneInfoVolume() {
            return isNil(this.ccloneInfo['scf_raw_data_result']) ? 'N/A' : this.ccloneInfo['scf_raw_data_result']['non_empty_positives']
        },
        ccloneInfoRealNegativeEvents() {
            return isNil(this.ccloneInfo['scf_raw_data_result']) ? 'N/A' : this.ccloneInfo['scf_raw_data_result']['non_empty_negatives']
        },
        ccloneDisableStartAction() {
            return this.ccloneInfo.status === 'failed' && ['webo_admin', 'webo_employee'].includes(this.userRole)
        },

        // Tabs navigation
        activeTab() {
            return this.activeTabCclone
        }
    },

    methods: {
        ...mapMutations('ui/cclone', { setIsEditing: 'setIsEditing' }),
        ...mapActions('data/cclone', ['editCclone']),
        onCcloneEdit() {
            this.setIsEditing({ isEditing: true })
            this.editCclone({ _ccloneInfo: { id: this.ccloneInfo.id }, onlyStatus: true })
        },
        formatDate(date) {
            return head(split(date, ' '))
        },
        itemCssClasses(element) {
            let cssClasses = ''
            if (element === 'waiting') cssClasses += ' is-waiting'
            if (element === 'running') cssClasses += ' is-running'
            if (element === 'available') cssClasses += ' is-available'
            if (element === 'failed') cssClasses += ' is-failed'

            return cssClasses
        }
    }
}
</script>
